module.exports = __webpack_public_path__ + "assets/order-by.b750ef2f.svg";